// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__gZEQG","footer":"ModalCreateQualiphyProcedure_footer__y-Dx6","additionData":"ModalCreateQualiphyProcedure_additionData__zQiXa"};